module.exports = __webpack_public_path__ + "static/media/image.8370599e.png";